import { createSelector } from '@reduxjs/toolkit'
import { IStore } from '../types'

export const selectNotificationData = createSelector(
	(state: IStore) => state.notification,
	(notification) => notification
)
